export type ReportsType = "tags-report"

export const reportsTypeToTitle: Record<ReportsType, string> = {
	"tags-report": "Relatório de Tags"
}
